import ReviewAPI from '../api/Reviews';
import * as ActionTypes from '../constants/ActionTypes';

export const getAllReviews = () => (dispatch) => {
    ReviewAPI.getReviews()
        .then(({data}) => {
            dispatch({
                type: ActionTypes.GET_ALL_REVIEWS,
                payload: data
            });
        });
};


// WEBPACK FOOTER //
// ./src/actions/Reviews.js